import React from "react";
import CountUp from "react-countup";
import { motion } from "framer-motion";
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles/About.css";
import FounderSection from './inc/FounderSection';
import GoogleReviews from "./inc/GoogleReviews";
import { Dot } from "lucide-react";
import UseSEO from "../../Hooks/useSEO";
import AutoScrollSection from "../common/AutoScrollSection";
import LazyImage from "../common/LazyImage";
import partners from "../../Data/partners";
//import RequestGoogleReview from "./inc/RequestGoogleReview";

const About = () => {

    // Use the hook at the top of the component suport in React 19
    UseSEO({
        title: "Sujaramaha Enterprises | Computer & Printers Sales & Services, CCTV,All types of Insurance, Water Filter / RO System & Kitchen Chimneys, Solar Water Heater, Inverter & Battery",
        description:
            "Sujaramaha Enterprises provides computer & Printers sales and services, All types of insurance assistance, CCTV installation, Water Filter / RO System & Kitchen Chimneys, Solar Water Heater, Inverter & Battery with trusted local support.",
        keywords:
            "computer sales and services, Printer sales and services, All types of insurance assistance, CCTV installation, Water Filter / RO System & Kitchen Chimneys, Solar Water Heater, Inverter & Battery, Sujaramaha Enterprises"
    });

    return (
        <div className="about-page">

            {/* HERO */}
            <motion.section
                className="about-hero"
                initial={{ opacity: 0, y: -40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
            >
                <h1>Sujaramaha Enterprises</h1>
                <h2 className="tagline">A Legacy of Trust</h2>
                <p>Computer & Printers <Dot /> Insurance  <Dot /> CCTV Solutions <Dot /> Solar & Water Filter <Dot /> Inverter & Battary </p>
            </motion.section>

            {/* STATS */}
            <section className="stats-section">
                <div className="stat-box">
                    <CountUp end={5000} duration={3} />+
                    <p>Happy Customers</p>
                </div>
                <div className="stat-box">
                    <CountUp end={10} duration={3} />+
                    <p>Insurance Partners</p>
                </div>
                <div className="stat-box">
                    <CountUp end={8} duration={3} />+
                    <p>Years Experience</p>
                </div>
                <div className="stat-box">
                    <CountUp end={24} duration={3} />
                    <p>Support Hours</p>
                </div>
            </section>

            {/* OWNER */}
            {/* <motion.section
                className="owner-section"
                initial={{ opacity: 0, x: -60 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.7 }}
            >
                <h2>Founder & Owner</h2>
                <h3>Mahesh V J</h3>
                <p>
                    Founded with a vision to simplify insurance and technology services,
                    Sujaramaha Enterprises stands for transparency, trust, and long-term customer relationships.
                </p>
            </motion.section>*/}
            <FounderSection />

            {/* PARTNERS LOGO SCROLL */}
            <section className="partners-section">
                <h2>Our Trusted Partners</h2>
                <AutoScrollSection>
                <div className="partners-slider">


                        {partners.map((name) => {
                            const altText = name
                                .replace(/\.(webp|png|jpeg|jpg)$/i, "") // remove extension
                                .replace(/[-_]/g, " ")                  // replace - _
                                .toUpperCase();                         // optional formatting

                            return (
                                <LazyImage
                                    key={name}
                                    src={`/partners_images/${name}`}      // ✅ correct path
                                    alt={`Sujaramaha Enterprises ${altText} Partner Logo`}        // ✅ good alt text
                                />
                            );
                        })}

                        



                        

                        {/* {partners.map((name) => (
                            <LazyImage
                                key={name}
                                src={`../partners_images/${name}`}   //  ✅ EXTENSION INCLUDED
                                alt={name}
                            />
                        ))}

                        <img src={Hdfc} alt="HDFC Ergo" />
                    <img src={Icici} alt="ICICI Lombard" />
                    <img src={Bajaj} alt="Bajaj Allianz" />
                    <img src={Digit} alt="TATA AIG" />
                        <img src={Liberty} alt="Star Health" />
                        <img src={Reliance} alt="Star Health" />*/}

                    </div>
                </AutoScrollSection>
            </section>

            {/* GOOGLE REVIEWS */}
            <GoogleReviews />

            {/* Request GOOGLE REVIEWS 
            <RequestGoogleReview />*/}
            

        </div>
    );
};

export default About;
